export default __webpack_public_path__ + "static/data-about-screenshot-1--mobile-08344401f83b852bd2123182f3ec622a.webp";